<app-header-step [user]="user"
                 [queryParams]="queryParams"
                 step="3"
                 (updateInformation)="updateInformation(0)"></app-header-step>

<div style="height: 300px;">
  <div #spacer></div>
  <div class="main-spacer">
    <app-tile (onSelectTile)="selectTile($event)" [tile$]="selectTilesProduits$"></app-tile>
  </div>
</div>

<app-produit-caroussel
  [queryParams]="queryParams" [user]="user"></app-produit-caroussel>



